import 'css-chunksrc/client/scenes/workloads/wbs/preview/styles.scss';export default {
  "preview": "_preview_70nqt_1",
  "icon": "_icon_70nqt_9",
  "list": "_list_70nqt_19"
};